import React from 'react';
import './icon-list-styles.scss';

const IconsList = () => {
  return (
    <div className="items">
      <p className="editorial-large semibold mb-md">
        Alo Icons (
        <a
          className="editorial-large semibold underline"
          href="https://www.figma.com/design/6xudIyDqmcUDdRu0OZxjQP/GLOW-UI?node-id=5201-2202&t=u1Volg6SHkGPX5MG-4"
        >
          Reference
        </a>
        )
      </p>
      <div className="section-wrap section-wrap--large-gap column">
        <div>
          <h5 className="editorial mb-xl">Arrows</h5>
          <div className="icons-wrap">
            <span className="alo-arrow-up-icon"></span>
            <span className="alo-arrow-down-icon"></span>
            <span className="alo-arrow-left-icon"></span>
            <span className="alo-arrow-right-icon"></span>
            <span className="alo-chevron-up-icon"></span>
            <span className="alo-chevron-down-icon"></span>
            <span className="alo-chevron-left-icon"></span>
            <span className="alo-chevron-right-icon"></span>
            <span className="alo-chevron-up-thick-icon"></span>
            <span className="alo-chevron-down-thick-icon"></span>
            <span className="alo-chevron-left-thick-icon"></span>
            <span className="alo-chevron-right-thick-icon"></span>
          </div>
        </div>
        <div>
          <h5 className="editorial mb-md">Basic UI</h5>
          <div className="icons-wrap">
            <span className="alo-checkmark-icon"></span>
            <span className="alo-close-x-icon"></span>
            <span className="alo-kebab-icon"></span>
            <span className="alo-share-icon"></span>
            <span className="alo-sort-icon"></span>
            <span className="alo-calendar-icon"></span>
            <span className="alo-info-icon"></span>
            <span className="alo-alert-icon"></span>
            <span className="alo-edit-icon"></span>
            <span className="alo-clock-icon"></span>
            <span className="alo-history-icon"></span>
            <span className="alo-clock-moves-icon"></span>
            <span className="alo-block-icon"></span>
            <span className="alo-add-friend-icon"></span>
            <span className="alo-question-icon"></span>
            <span className="alo-question-solid-icon"></span>
            <span className="alo-loading-icon"></span>
            <span className="alo-face-id-icon"></span>
            <span className="alo-return-arrow-icon"></span>
            <span className="alo-cursor-arrow-icon"></span>
            <span className="alo-checkmark-in-circle-solid-icon"></span>
            <span className="alo-checkmark-in-circle-icon"></span>
            <span className="alo-circle-icon"></span>
            <span className="alo-circle-solid-icon"></span>
            <span className="alo-circle-plus-icon"></span>
            <span className="alo-circle-plus-solid-icon"></span>
            <span className="alo-checkmark-in-square-solid-icon"></span>
            <span className="alo-checkmark-in-square-icon"></span>
            <span className="alo-square-icon"></span>
            <span className="alo-eye-icon"></span>
            <span className="alo-eye-slash-icon"></span>
            <span className="alo-warning-icon"></span>
            <span className="alo-warning-solid-icon"></span>
            <span className="alo-arrow-up-thick-icon"></span>
            <span className="alo-arrow-down-thick-icon"></span>
            <span className="alo-arrow-left-thick-icon"></span>
            <span className="alo-arrow-right-thick-icon"></span>
            <span className="alo-add-icon"></span>
            <span className="alo-add-thick-icon"></span>
            <span className="alo-subtract-icon"></span>
            <span className="alo-subtract-thick-icon"></span>
          </div>
        </div>
        <div>
          <h5 className="editorial mb-md">Content labels</h5>
          <div className="icons-wrap">
            <span className="alo-gift-icon"></span>
            <span className="alo-location-pin-icon"></span>
            <span className="alo-explore-icon"></span>
            <span className="alo-series-icon"></span>
            <span className="alo-round-play-icon"></span>
            <span className="alo-instructors-icon"></span>
            <span className="alo-category-icon"></span>
            <span className="alo-cube-icon"></span>
            <span className="alo-lock-icon"></span>
            <span className="alo-unlock-icon"></span>
            <span className="alo-ruler-icon"></span>
            <span className="alo-twinkle-icon"></span>
            <span className="alo-twinkle-solid-icon"></span>
            <span className="alo-camera-icon"></span>
            <span className="alo-image-icon"></span>
            <span className="alo-camera-solid-icon"></span>
            <span className="alo-bell-plus-icon"></span>
            <span className="alo-status-circle-indicator-icon"></span>
            <span className="alo-chat-icon"></span>
            <span className="alo-shipping-icon"></span>
            <span className="alo-preferences-icon"></span>
            <span className="alo-sweatshop-icon"></span>
            <span className="alo-school-icon"></span>
            <span className="alo-truck-icon"></span>
            <span className="alo-truck-solid-icon"></span>
            <span className="alo-clock-icon"></span>
            <span className="alo-phone-icon"></span>
            <span className="alo-email-icon"></span>
            <span className="alo-rectangle-edit-icon"></span>
            <span className="alo-hanger-icon"></span>
            <span className="alo-meditation-icon"></span>
            <span className="alo-double-heat-wave-icon"></span>
            <span className="alo-heat-wave-icon"></span>
            <span className="alo-single-heat-wave-icon"></span>
          </div>
        </div>
        <div>
          <h5 className="editorial mb-md">Reactions</h5>
          <div className="icons-wrap">
            <span className="alo-thumb-up-icon"></span>
            <span className="alo-thumb-up-solid-icon"></span>
            <span className="alo-thumb-down-icon"></span>
            <span className="alo-thumb-down-solid-icon"></span>
            <span className="alo-star-icon"></span>
            <span className="alo-star-solid-icon"></span>
            <span className="alo-comment-icon"></span>
            <span className="alo-heart-solid-icon"></span>
            <span className="alo-heart-icon"></span>
          </div>
        </div>
        <div>
          <h5 className="editorial mb-md">Platforms</h5>
          <div className="icons-wrap">
            <span className="alo-chrome-icon"></span>
            <span className="alo-apple-icon"></span>
            <span className="alo-google-play-icon"></span>
            <span className="alo-instagram-logo-icon"></span>
            <span className="alo-facebook-logo-icon"></span>
            <span className="alo-google-logo-icon"></span>
            <span className="alo-google-color-logo-icon"></span>
            <span className="alo-globe-icon"></span>
            <span className="alo-mail-icon"></span>
            <span className="alo-laptop-icon"></span>
            <span className="alo-amazon-color-logo-icon"></span>
            <span className="alo-amazon-logo-icon"></span>
            <span className="alo-facebook-f-icon"></span>
            <span className="alo-tiktok-icon"></span>
            <span className="alo-youtube-icon"></span>
            <span className="alo-x-logo-icon"></span>
          </div>
        </div>
        <div>
          <h5 className="editorial mb-md">Content controls</h5>
          <div className="icons-wrap">
            <span className="alo-schedule-icon"></span>
            <span className="alo-scheduled-icon"></span>
            <span className="alo-bell-plus-icon"></span>
            <span className="alo-bell-icon"></span>
          </div>
        </div>
        <div>
          <h5 className="editorial mb-md">Media controls</h5>
          <div className="icons-wrap">
            <span className="alo-pause-icon"></span>
            <span className="alo-play-icon"></span>
            <span className="alo-filters-icon"></span>
            <span className="alo-filters-vertical-icon"></span>
          </div>
        </div>
        <div>
          <h5 className="editorial mb-md">Navigation</h5>
          <div className="icons-wrap">
            <span className="alo-home-icon"></span>
            <span className="alo-home-solid-icon"></span>
            <span className="alo-account-solid-icon"></span>
            <span className="alo-account-icon"></span>
            <span className="alo-search-burger-icon"></span>
            <span className="alo-search-burger-solid-icon"></span>
            <span className="alo-shopping-bag-icon"></span>
            <span className="alo-shopping-bag-solid-icon"></span>
            <span className="alo-browse-icon"></span>
            <span className="alo-browse-solid-icon"></span>
            <span className="alo-activity-icon"></span>
            <span className="alo-activity-thick-icon"></span>
            <span className="alo-hamburger-icon"></span>
            <span className="alo-drag-icon"></span>
            <span className="alo-settings-icon"></span>
            <span className="alo-missing-icon"></span>
            <span className="alo-search-icon"></span>
            <span className="alo-search-flipped-icon"></span>
            <span className="alo-search-thick-icon"></span>
            <span className="alo-search-flipped-thick-icon"></span>
          </div>
        </div>
        <div>
          <h5 className="editorial mb-md">Ecommerce</h5>
          <div className="icons-wrap">
            <span className="alo-quick-add-icon"></span>
            <span className="alo-cartbag-icon"></span>
            <span className="alo-cartbag-solid-icon"></span>
          </div>
        </div>
        <div>
          <h5 className="editorial mb-md">Logos</h5>
          <div className="icons-wrap">
            <span className="alo-reshop-logo-icon"></span>
            <span className="alo-afterpay-logo-icon"></span>
            <span className="alo-logo-icon"></span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IconsList;
